import {createContext, useCallback, useContext} from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const TaxonomyDictionaryApiContext = createContext(null);

export function TaxonomyDictionaryApiProvider({ children }) {
    const { get, post, patch, del } = useApiService(CONFIG.SERVER_ASSISTANT);

    const getTaxonomyDictionary = useCallback(async (skip, limit) => {
        if (!skip) {
            skip = 0;
        }
        if (!limit) {
            limit = 10;
        }
        try {
            const response = await get(`/v1/taxonomy_dictionary?skip=${skip}&limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching taxonomy dictionary:", error);
            throw error;
        }
    }, [get]);

    const getTaxonomyDictionaryById = useCallback(async (dictionaryId) => {
        try {
            const response = await get(`/v1/taxonomy_dictionary/${dictionaryId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching taxonomy dictionary by ID:", error);
            throw error;
        }
    }, [get]);

    const createTaxonomyDictionary = useCallback(async (data) => {
        try {
            const response = await post(`/v1/taxonomy_dictionary`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating taxonomy dictionary:", error);
            throw error;
        }
    }, [post]);

    const updateTaxonomyDictionary = useCallback(async (dictionaryId, data) => {
        try {
            const response = await patch(`/v1/taxonomy_dictionary/${dictionaryId}`, data);
            return response.data;
        } catch (error) {
            console.error("Error updating taxonomy dictionary:", error);
            throw error;
        }
    }, [patch]);

    const deleteTaxonomyDictionary = useCallback(async (dictionaryId) => {
        try {
            const response = await del(`/v1/taxonomy_dictionary/${dictionaryId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting taxonomy dictionary:", error);
            throw error;
        }
    }, [del]);
    return (
        <TaxonomyDictionaryApiContext.Provider value={{
            getTaxonomyDictionary,
            getTaxonomyDictionaryById,
            createTaxonomyDictionary,
            updateTaxonomyDictionary,
            deleteTaxonomyDictionary
        }}>
            {children}
        </TaxonomyDictionaryApiContext.Provider>
    )
}

export function useTaxonomyDictionaryApi() {
    const context = useContext(TaxonomyDictionaryApiContext);
    if (!context) {
        throw new Error("useTaxonomyDictionaryApi must be used within a TaxonomyDictionaryApiProvider");
    }
    return context;
}
